import { scaleW } from '@/common/style';
import { Model } from '@/request';
import { Box, Flex } from '@kibt/meta-ui-krn';
import React from 'react';
import Image from '@kds/image';
import { isIOS } from '@kibt/krn-utils';
import { useDetailPageStore } from '@/page/detail/store';
import { GirdleStyle, NetPrice } from '../../../api';
import { KImageBackground, KText } from '@/component/RtlLayout';

export type ItemInfo = Model['GET/rest/o/ecom/customer/item/info']['responses']['data'];
export const ActivityType = {
    FlashSale: 2001, // 秒杀活动
    Exclusive: 2005, // 达人专享
    HotItemFlash: 2006, // 爆款直降
};
export function CaculateBlock({ list, styleConfig, fallbackTips }: { list: any; styleConfig: any; fallbackTips: string }) {
    function renderPriceItem({ label, value }: { label: string; value: string }) {
        return (
            <Flex flex={'flexCol'} bs={{ h: '100%' }}>
                <KText
                    style={{
                        fontSize: scaleW(9),
                        color: styleConfig?.activityColor || '#fff',
                        fontWeight: isIOS ? '400' : '500',
                        lineHeight: scaleW(10),
                        marginTop: scaleW(2),
                    }}>
                    {label}
                </KText>
                <KText
                    style={{
                        fontSize: scaleW(12),
                        color: styleConfig?.activityColor || '#fff',
                        fontWeight: isIOS ? '400' : '500',
                        lineHeight: scaleW(14),
                        marginTop: scaleW(3),
                    }}>
                    {value}
                </KText>
            </Flex>
        );
    }

    const subNode = (
        <Flex
            flex={'flexCenter'}
            bs={{ alignSelf: 'flex-end', mb: 3, mr: list.length === 3 ? scaleW(4) : scaleW(12), ml: list.length === 3 ? scaleW(2) : scaleW(12) }}>
            <Image style={{"width":"2.4154589371980677rem","height":"2.4154589371980677rem"}} source={{ uri: styleConfig?.activityIcon }} />
        </Flex>
    );

    return (
        <Flex flex={'flexRowCenter'} bs={{ py: 6 }}>
            {list ? (
                list.map((it, index) =>
                    index !== list.length - 1 ? (
                        <>
                            {renderPriceItem({
                                label: it.name,
                                value: it.displayPrice,
                            })}
                            {subNode}
                        </>
                    ) : (
                        renderPriceItem({
                            label: it.name,
                            value: it.displayPrice,
                        })
                    )
                )
            ) : fallbackTips ? (
                <KText style={{ color: styleConfig?.activityColor || '#fff', fontSize: scaleW(14), fontWeight: isIOS ? '400' : '500' }}>
                    {fallbackTips}
                </KText>
            ) : null}
        </Flex>
    );
}

export function BigSalesCalculatorBanner(props: { defalutChild: JSX.Element }) {
    const { defalutChild } = props;
    const { currentSku, bigMarketingBanner } = useDetailPageStore(s => ({
        currentSku: s.currentSku,
        bigMarketingBanner: s.bigMarketingBanner,
    }));
    //腰封展示的主活动
    //倒计时配置
    // 获取当前sku
    const currentSkuId = currentSku?.skuId || bigMarketingBanner?.defaultSkuId;
    // 获取当前规格的到手价区域展示信息
    const netPrice = bigMarketingBanner?.netPrice?.[currentSkuId] || ({} as NetPrice);
    // 获取当前规格下的优惠区域展示信息
    const priceCalculator = bigMarketingBanner?.priceCalculator?.[currentSkuId] || false;
    // 当有三个活动时，整体可能变得紧凑一些，代码留着
    // const isCompact = priceCalculator?.length === 3 ? true : false

    // 当有活动时，定时刷新商详页. 库存小于10或者倒计时小于5分钟

    // 动态化腰封氛围配置信息
    const styleConfig = bigMarketingBanner?.style || ({} as GirdleStyle);

    function renderPriceItem({ label, value }: { label: string; value: string }) {
        return (
            <Flex flex={'flexCol'} bs={{ h: '100%' }}>
                <KText
                    style={{
                        fontSize: scaleW(9),
                        color: styleConfig?.activityColor || 'rgba(0, 0, 0, 0.88)',
                        fontWeight: '500',
                        lineHeight: scaleW(11),
                        marginTop: scaleW(20),
                    }}>
                    {label}
                </KText>
                <KText
                    style={{
                        fontSize: scaleW(12),
                        color: styleConfig?.activityColor || 'rgba(0, 0, 0, 0.88)',
                        fontWeight: '700',
                        lineHeight: scaleW(14),
                        marginTop: scaleW(4),
                    }}>
                    {value}
                </KText>
            </Flex>
        );
    }

    const subNode = (
        <Flex
            flex={'flexCenter'}
            bs={{
                alignSelf: 'flex-end',
                mb: 3,
                mr: priceCalculator.length === 3 ? scaleW(4) : scaleW(12),
                ml: priceCalculator.length === 3 ? scaleW(2) : scaleW(12),
                height: '100%',
                paddingTop: scaleW(26),
            }}>
            <KText style={{"fontWeight":"700","color":"rgba(0, 0, 0, 0.24)"}}>-</KText>
        </Flex>
    );

    return (
        <KImageBackground source={{ uri: styleConfig.bgImg2 || '' }} style={{"width":"100%"}}>
            {priceCalculator ? (
                <Flex flex={'flexRowCenter'} bs={{ height: scaleW(61), justifyContent: 'space-between' }}>
                    <Box
                        bs={{
                            height: '100%',
                            paddingTop: 8,
                            paddingLeft: 12,
                            paddingBottom: 7,
                            justifyContent: 'space-between',
                        }}>
                        <KText style={[{ fontSize: scaleW(12), fontWeight: '500' }, { color: styleConfig?.netPriceColor || 'rgba(255, 73, 6, 1)' }]}>
                            {netPrice.name}
                        </KText>
                        <KText
                            style={[
                                { fontWeight: '700' },
                                {
                                    fontSize: netPrice?.displayPrice?.length > 7 ? scaleW(20) : scaleW(24),
                                    color: styleConfig?.netPriceColor || 'rgba(255, 73, 6, 1)',
                                },
                            ]}>
                            {netPrice?.displayPrice}
                        </KText>
                    </Box>
                    <Box style={{"flexBasis":26,"flex":1,"paddingTop":"5.314009661835749rem","alignItems":"center","maxWidth":"10.144927536231885rem"}}>
                        <KText style={{"fontSize":"3.8647342995169085rem","fontWeight":"700","lineHeight":"4.5893719806763285rem","color":"rgba(0, 0, 0, 0.24)"}}>=</KText>
                    </Box>
                    <Box
                        style={{"flexBasis":32,"flex":2,"flexDirection":"row","justifyContent":"flex-start","paddingRight":"3.381642512077295rem","height":"100%"}}>
                        {priceCalculator.map((it, index) =>
                            index !== priceCalculator.length - 1 ? (
                                <>
                                    {renderPriceItem({
                                        label: it.name,
                                        value: it.displayPrice,
                                    })}
                                    {subNode}
                                </>
                            ) : (
                                renderPriceItem({
                                    label: it.name,
                                    value: it.displayPrice,
                                })
                            )
                        )}
                    </Box>
                </Flex>
            ) : (
                defalutChild
            )}
        </KImageBackground>
    );
}
